<template>
  <section id="customers" class="grey lighten-4 pb-8">
    <v-container class="exptra-padding">
      <v-row justify="start" align="center">
        <v-col cols="12" class="mb-10">
          <h1 class="text-h2 text-uppercase text-center primary--text">
            NUESTROS CLIENTES
          </h1>
          <v-divider class="pt-1 mx-auto my-2 secondary" width="50"></v-divider>
          <p
            class="font-weight-light grey--text text-justify text-center text-body-1"
          >
            Para nosotros lo más importante es que nuestros clientes,
            particulares y empresas, queden completamente satisfechos con los
            servicios que brindamos. En Argecam contamos con personal calificado
            para realizar todas las obras viales.
          </p>
        </v-col>
        <v-col v-for="c in clientes" :key="c.i" cols="6" sm="3" md="3" lg="2">
          <v-skeleton-loader
            :loading="loading"
            transition="scale-transition"
            class="mx-auto"
            max-width="200"
            height="100"
            type="image"
          >
            <v-hover v-slot:default="{ hover }" open-delay="100">
              <v-img
                :src="require('@/assets/clientes-argecam/' + c.link)"
                :alt="c.alt"
                :class="hover ? 'sinfiltro elevation-10' : 'filtro elevation-1'"
                class="mx-auto rounded-lg white"
                contain
                height="100"
                width="100"
              />
            </v-hover>
          </v-skeleton-loader>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "Customers",
  props: {
    loading: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    clientes: [
      {
        link: "criba-sa.jpg",
        alt: "Logo de Criba S.A."
      },
      {
        link: "cunumi-sa.jpg",
        alt: "Logo de Cunumi S.A."
      },
      {
        link: "dycasa-sa.jpg",
        alt: "Logo de Dycasa S.A."
      },
      {
        link: "esuco-sa.jpg",
        alt: "Logo de Esuco S.A."
      },

      {
        link: "ingeniero-pellegrinet-sa.jpg",
        alt: "Logo Ingeniero Pellegrinet S.A."
      },
      {
        link: "luis-losi-sa.jpg",
        alt: "Logo de Luis Losi S.A."
      },
      {
        link: "reconstruccion-canos-sa.jpg",
        alt: "Logo de Reconstruccion Canos S.A."
      },
      {
        link: "riva-sa.jpg",
        alt: "Logo Riva S.A."
      },
      {
        link: "rovella-carranza-sa.jpg",
        alt: "Logo Rovella Carranza S.A."
      },
      {
        link: "rowing-sa.jpg",
        alt: "Logo de Rowing S.A."
      },
      {
        link: "ses-sa.jpg",
        alt: "Logo de SES S.A."
      },
      {
        link: "sudamericana-sa.jpg",
        alt: "Logo de Sudamericana S.A."
      },
      {
        link: "pentamar-sa.jpg",
        alt: "Logo de Pentamar S.A."
      },
      {
        link: "penedile-sa.jpg",
        alt: "Logo de Penedile S.A."
      },
      {
        link: "vidogar-sa.jpg",
        alt: "Logo de Vidogar S.A."
      },
      {
        link: "sacde-sa.jpg",
        alt: "Logo de Sacde S.A."
      }
    ]
  })
};
</script>

<style scoped>
.filtro {
  filter: grayscale(1);
  transition: ease-in 0.5s;
}
.sinfiltro {
  filter: none;
  transform: scale(1.2);
  transition: ease-out 0.5s;
  cursor: pointer;
}
</style>
